module.exports = new __parcel__URL__("tools-darkmode.8c16d867.svg").toString();